var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "table",
    {
      staticClass: "table",
      class: { "table--rounded-theme": _vm.theme === "rounded" },
    },
    [
      _c("thead", [
        _c(
          "tr",
          _vm._l(_vm.fields, function (field, index) {
            return _c(
              "th",
              { key: index },
              [
                _vm.columnsLink[index]
                  ? _c(
                      "router-link",
                      {
                        staticClass: "link link--black link--underline",
                        attrs: { to: _vm.columnsLink[index] },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(field) +
                            "\n                "
                        ),
                      ]
                    )
                  : _c("span", [_vm._v(_vm._s(field))]),
              ],
              1
            )
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _c(
        "tbody",
        _vm._l(_vm.tableData, function (item, index) {
          return _c(
            "tr",
            { key: index },
            _vm._l(_vm.fields, function (field) {
              return _c("td", {
                key: item[field],
                domProps: { innerHTML: _vm._s(item[field]) },
              })
            }),
            0
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }